





























import {Component, Vue, Prop, Mixins} from 'vue-property-decorator';
import {PaymentOptions} from "@/types/CheckoutFormData";
import {Mixin} from "@/mixins";
import {Option} from "@/types/CheckoutServerData";

@Component({
    name: "PaymentIcons",
})
export default class PaymentIcons extends Mixins(Mixin) {
    PaymentOptions = PaymentOptions;
    measureFitWarrantyLink = measureFitWarrantyLink;
    trustedShopsLink = trustedShopsLink;

    @Prop()
    protected readonly payments!: { [key: number]: Option };

    public mounted(): void {
        window.initTrustedShops();
    }

    protected get showTrustedShops() {
        return 'initTrustedShops' in window;
    }
}
